import { DateTime } from "luxon";

export function getLocalDateText (date: string)
{
  let dt;
  
  if ((date + '').indexOf("/") > -1) 
  {
    dt = DateTime.fromFormat(date,'MM/dd/yyyy', {zone: 'utc'});
  }
  else
  {
    dt = DateTime.fromISO(date, {zone: 'utc'});
  }

  return dt.isValid ? dt.setZone('utc').toLocaleString({month: "2-digit", day: "2-digit", year: 'numeric'}) : '';
}
